<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>新聞稿
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="PcDevice">
        <div class="contentBoxStatus">
          <Dashboard></Dashboard>
        </div>
        <div class="my-3"></div>
      </div>

      <div class="contentBox">
        <!-- <p class="mb-2 text-center" style="font-size: 15px;">為確保參觀者能清楚了解您的公司、產品及服務內容，請務必完成下列各個項目的資料上傳</p>

                <div class="mb-4 border  text-center py-2"
                    style="font-size:15px ;margin-right:17%; margin-left:17%; border-radius:30px">
                    <div class="d-flex justify-content-around">

                        <a :href="`profile?no=${RegNo}`">
                            <div class="d-flex align-items-center">
                                <span class="complete mr-1"></span>
                                <span style="color:black">基本資料
                                </span>
                            </div>
                        </a>

                        <a :href="`product?no=${RegNo}`">

                            <div class="d-flex align-items-center">
                                <span class="uncomplete mr-1"></span>
                                <span class="border-dark  text-dark" style="font-size:15px">參展產品
                                </span>
                            </div>
                        </a>

                        <a :href="`news?no=${RegNo}`">

                            <div class="d-flex align-items-center">
                                <span class="complete mr-1"></span>
                                <span style="color:black">新聞稿
                                </span>
                            </div>
                        </a>

                        <a :href="`video?no=${RegNo}`">

                            <div class="d-flex align-items-center">
                                <span class="complete mr-1"></span>
                                <span style="color:black">參展商影音
                                </span>
                            </div>
                        </a>

                        <a :href="`onlineExpo?no=${RegNo}`">

                            <div class="d-flex align-items-center">
                                <span class="uncomplete mr-1"></span>
                                <span style="color:black">線上展覽設定
                                </span>
                            </div>
                        </a>

                    </div> -->
        <!-- </div> -->

        <div class="MbDevice">
          <Dashboard></Dashboard>
        </div>

        <h1>新聞稿</h1>
        <p class="my-3">&nbsp;</p>

        <p class="alert">
          您已經發佈
          <span class="red" name="existProd">{{ NewsNum }}</span>
          篇新聞稿，還可以發佈
          <span class="red" name="leftAmount">{{
            NewsAvaliable - NewsNum
          }}</span>
          篇新聞稿，依最後更新時間排序
        </p>
        <p class="my-3">&nbsp;</p>

        <div class="d-flex align-items-center">
          <span class="PcDevice">
            <div
              class="btn btn-lg btn-primary mx-3 text-nowrap"
              @click.prevent="toAddNews"
            >
              建立新聞稿
            </div>
          </span>
          <span class="MbDevice">
            <div
              class="btn btn-primary mr-2 text-nowrap"
              @click.prevent="toAddNews"
            >
              建立新聞稿
            </div>
          </span>
          <div>
            需要發佈更多新聞稿嗎？請參考<a
              :href="`upgrade?no=${RegNo}`"
              class=" "
              >加值服務方案</a
            >。
          </div>
        </div>
        <p class="my-3">&nbsp;</p>

        <div class="PcDevice">
          <ul
            id="product"
            v-for="(item, index) in newsList"
            :key="index"
            class="mx-4"
          >
            <li class="mx-4">
              <div class="innerLeft">
                <div class="text-left text-md-left">
                  <div class="formTitle my-2" style="font-size: 18px">
                    <span v-if="LocalExh">
                      {{ item.NewsTopic }}
                    </span>
                    <span v-else>
                      {{ item.eNewsTopic }}
                    </span>
                  </div>
                  <p class="gray">
                    官網狀態：
                    <span class="text-danger" v-if="item.Archived == 1"
                      >隱藏</span
                    >
                    <span class="text-success" v-else>顯示</span>
                  </p>
                  <p class="gray">
                    前台：
                    <span v-if="item.Archived == 1">
                      <i class="fas fa-eye mr-1"></i>
                      <span
                        style="color: #1a73e8"
                        class="Preview-style"
                        @click="openModal(item.NewsNo)"
                        >預覽頁面</span
                      >
                    </span>
                    <span v-else>
                      <span v-if="NewExhcode">
                        <i class="fas fa-eye mr-1"></i>
                        <a
                          :href="item.ExhWebsiteNewsUrl"
                          target="_blank"
                          >頁面快速連結</a
                        >
                      </span>
                      <span v-else-if="!NewExhcode">
                        <i class="fas fa-eye mr-1"></i>
                        <span
                          style="color: #1a73e8"
                          class="Preview-style"
                          @click="openModal(item.NewsNo)"
                          >預覽頁面</span
                        >
                      </span>
                    </span>
                  </p>
                  <p class="gray">更新：{{ item.UpdateTime }}</p>
                </div>
              </div>
              <div class="innerRight">
                <div class="mt-4">
                  <p>
                    <span
                      class="btnStyle"
                      @click.prevent="toEditNews(item.NewsNo)"
                      >修改</span
                    >
                    <span
                      class="btnStyle btnGray ml-2"
                      @click.prevent="delNews(item.NewsNo)"
                      >刪除</span
                    >
                  </p>
                </div>
              </div>
              <p class="clear"></p>
            </li>
            <hr />
          </ul>
        </div>

        <div class="MbDevice">
          <div class="col-lg-10 text-dark">
            <div class="row">
              <div
                class="col-sm-6 mb-2"
                v-for="(item, index) in newsList"
                :key="index"
              >
                <div class="card mt-4">
                  <div class="card-body">
                    <ul class="list-group list-group-flush mx-2">
                      <div class="my-2" style="font-size: 15px">
                        <div v-if="LocalExh">
                          <strong>{{ item.NewsTopic }}</strong>
                        </div>
                        <div v-else>
                          <strong>{{ item.eNewsTopic }}</strong>
                        </div>
                      </div>
                      <p class="gray">
                        前台：
                        <span v-if="item.Archived == 1">
                          <i class="fas fa-eye mr-1"></i>
                          <span
                            style="color: #1a73e8"
                            class="Preview-style"
                            @click="openModal(item.NewsNo)"
                            >預覽頁面</span
                          >
                        </span>
                        <span v-else>
                          <span v-if="NewExhcode">
                            <i class="fas fa-eye mr-1"></i>
                            <a
                              :href="item.ExhWebsiteNewsUrl"
                              target="_blank"
                              >頁面快速連結</a
                            >
                          </span>
                          <span v-else-if="!NewExhcode">
                            <i class="fas fa-eye mr-1"></i>
                            <span
                              style="color: #1a73e8"
                              class="Preview-style"
                              @click="openModal(item.NewsNo)"
                              >預覽頁面</span
                            >
                          </span>
                        </span>
                      </p>
                      <p class="gray">更新：{{ item.UpdateTime }}</p>
                      <br />
                      <div class="card-footer">
                        <div
                          class="d-flex justify-content-between align-items-center mt-2"
                        >
                          <div>
                            官網狀態 :
                            <span
                              class="text-danger text-nowrap"
                              v-if="item.Archived === 1"
                              >隱藏</span
                            >
                            <span v-else class="text-success text-nowrap"
                              >顯示</span
                            >
                          </div>
                          <div>
                            <div
                              class="btn btn-sm btn-primary"
                              @click.prevent="toEditNews(item.NewsNo)"
                            >
                              修改
                            </div>
                            <div
                              class="btn btn-sm btn-secondary btn-primary ml-1"
                              @click.prevent="delNews(item.NewsNo)"
                            >
                              刪除
                            </div>
                          </div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div
          class="modal fade"
          id="openModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="ModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <div class="PcDevice">
                  <div class="modal-title h3" id="ModalLabel">
                    <i class="fas fa-eye mr-1"></i> 新聞稿預覽畫面
                  </div>
                </div>
                <div class="MbDevice">
                  <div class="modal-title h5" id="ModalLabel">
                    <i class="fas fa-eye mr-1"></i> 新聞稿預覽畫面
                  </div>
                </div>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <nav>
                <div class="nav mt-5 mx-3 nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    >中文版</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="nav-profile-tab"
                    data-toggle="tab"
                    href="#nav-profile"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >English</a
                  >
                </div>
              </nav>

              <div class="tab-content mx-2" id="pills-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div class="modal-body">
                    <div class="title-text-style font-weight-bold my-4">
                      {{ ModalData.NewsTopic }}
                    </div>
                    <p>廠商名稱 : {{ CompanyName }}</p>
                    <p>發佈日期 : {{ updateTime }}</p>
                    <p>攤位號碼 : {{ BoothNo }}</p>
                    <div
                      class="mt-5 mb-4 overflow-auto"
                      v-html="ModalData.NewsContent"
                    >
                      {{ ModalData.NewsContent }}
                    </div>
                    <div v-if="ModalData.NewsUrl">
                      <a :href="ModalData.NewsUrl" target="_blank"
                        >更多資訊請點擊繼續瀏覽(外部連結)</a
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                >
                  <div class="modal-body">
                    <div class="title-text-style font-weight-bold my-4">
                      {{ ModalData.eNewsTopic }}
                    </div>
                    <p>Exhibitor : {{ eComName }}</p>
                    <p>Date : {{ updateTime }}</p>
                    <p>Booth No. : {{ BoothNo }}</p>
                    <div
                      class="mt-5 mb-4 overflow-auto"
                      v-html="ModalData.eNewsContent"
                    >
                      {{ ModalData.eNewsContent }}
                    </div>
                    <div v-if="ModalData.eNewsUrl">
                      <a :href="ModalData.eNewsUrl" target="_blank"
                        >Related Link</a
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <div class="PcDevice">
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
                <div class="MbDevice">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import Dashboard from "@/components/Dashboard.vue";

import $ from "jquery";
import axios from "axios";

export default {
  components: {
    Dashboard,
  },
  metaInfo() {
    return {
      title: "新聞稿 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      LocalExh: true,
      UserId: "",
      CSRF_Token: "",
      newsList: [],
      NewsNum: 0, //目前發佈數
      RegNo: "",
      CompanyName: "",
      eComName: "",
      BoothNo: "",
      ModalData: [],
      lang: "tw",
      updateTime: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      HasOnlineExpo: "",
      openOnlineExpo: "",
      showOnlineStatus: false,

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      NewsAvaliable: 0,
      NewExhcode: true, //新聞稿額度
    };
  },
  methods: {
    openEnModal(id) {
      const vm = this;
      let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        vm.ModalData = response.data.Data;
        vm.updateTime = response.data.Data.UpdateTime.split(" ")[0];
      });
      $('#openModal a[href="#nav-profile"]').tab("show");

      $("#openModal").modal("show");
    },

    openModal(id) {
      const vm = this;
      let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        vm.ModalData = response.data.Data;
        vm.updateTime = response.data.Data.UpdateTime.split(" ")[0];
      });
      $('#openModal a[href="#nav-home"]').tab("show");

      $("#openModal").modal("show");
    },

    toAddNews() {
      const vm = this;

      if (vm.lang == "tw") {
        if (vm.NewsNum < vm.NewsAvaliable) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/newsAdd?no=${vm.RegNo}`;
        } else {
          alert("您已無發佈新聞稿的額度！");
        }
      } else {
        if (vm.NewsNum < vm.NewsAvaliable) {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/newsAdd?no=${vm.RegNo}`;
        } else {
          alert("You have reached the limit of amount of news published!");
        }
      }
    },

    toEditNews(id) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/newsEdit?no=${vm.RegNo}&id=${id}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/newsEdit?no=${vm.RegNo}&id=${id}`;
      }
    },

    toValuePage() {
      const vm = this;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/upgrade?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/upgrade?no=${vm.RegNo}`;
      }
    },

    delNews(id) {
      const vm = this;

      const info = {
        CSRF: vm.CSRF_Token,
      };

      const url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}?NewsNo=${id}`;

      if (vm.lang == "tw") {
        if (confirm("請確認要刪除此篇新聞稿嗎？")) {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("系統忙碌，請稍後再試！");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            }
          });
        } else {
          return false;
        }
      } else {
        if (confirm("Delete this news? ")) {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              alert("News successfully deleted! ");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 251) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/news?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 500) {
              alert("System is busy, please try again later.");
            }
          });
        } else {
          return false;
        }
      }
    },
  },

  created() {
    const vm = this;

    //取得語系

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/VIP/Info/${vm.RegNo}`)
      .then((response) => {
        vm.NewsAvaliable = response.data.Data.NewsAmount;
      });

    //新聞稿額度
    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`)
      .then((response) => {
        // console.log(response.data)

        vm.CompanyName = response.data.Data.Company;
        vm.BoothNo = response.data.Data.BoothNo;
        vm.eComName = response.data.Data.Directory_eComName;

        //取得是否填寫狀態盤的值

        vm.OnlineExpolayoutStatus = response.data.Data.OnlineExpolayoutStatus;
        vm.PressReleaseStatus = response.data.Data.PressReleaseStatus;
        vm.VideoStatus = response.data.Data.VideoStatus;
        vm.ProductStatus = response.data.Data.ProductStatus;
        vm.BasicinformationStatus = response.data.Data.BasicinformationStatus;

        vm.HasOnlineExpo = response.data.Data.Virtual;

        //取得是否開啟線上展權限
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`,
          )
          .then((response) => {
            // console.log(response.data.Data)
            vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
            vm.ExhBegin = response.data.Data.ExhBegin;
            vm.ExhEnd = response.data.Data.ExhEnd;
            vm.ExhVenue = response.data.Data.ExhVenue;
            vm.eExhVenue = response.data.Data.eExhVenue;
            let ExhCodeChangeDate = response.data.Data.ExhCodeChangeDate;

            if (ExhCodeChangeDate) {
              const targetDate = new Date(ExhCodeChangeDate);
              vm.NewExhcode = new Date() >= targetDate;
            }

            let ExpoLocation = response.data.Data.ExpoLocation;

            if (ExpoLocation === "T" || ExpoLocation === null) {
              vm.LocalExh = true;
            } else {
              vm.LocalExh = false;
            }
          });
      });

    let url = `/apiExhibitors/ExhibitorNews/${vm.RegNo}?Page=1`;
    axios.get(url).then(function (response) {
      if (response.data.Code == 200) {
        vm.newsList = response.data.Data;
        vm.NewsNum = response.data.datatotal;
      } else if (response.data.Code == 404) {
        vm.newsList = "";
        vm.NewsNum = 0;
      }
    });
  },
};
</script>

<style lang="scss">
.card-footer {
  padding: 0.5rem 0.2rem;
  background-color: rgb(255 255 255 / 3%);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header {
  padding: 0.35rem 0.8rem;
  margin-bottom: 0;
  background-color: #e9eef4;
  border-bottom: 0px;
}

.card-body {
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0.5rem;
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}
</style>
